import request from '@/utils/request'

// 查询泰山品质通知公告列表
export function listTspztzgg(query) {
  return request({
    url: '/web/zlts/tspztzgg/list',
    method: 'get',
    params: query
  })
}

// 查询泰山品质通知公告详细
export function getTspztzgg(recid) {
  return request({
    url: '/web/zlts/tspztzgg/' + recid,
    method: 'get'
  })
}
